import Config from "services/config/config";
import callWebService, {
    callTypes
} from "services/utils/networks/network";
import {LISTING, TRANSACTION, APPROVAL_LIST, ADD_MONEY, APPROVAL_LIST_DATA, VIEW_REQUEST, REQUEST_ACTION, WALLET_FINANCE_REQUEST, REQUEST_TRANSACTION_LIST, WALLET_REQUEST_LIST,FETCH_DEALER_DATA,LISTING_DEALER,LISTING_DEALER_APPROVAL} from "./type";

export const walletListingDealer = (page) => async (dispatch) => {
  try {
    dispatch({
        type: LISTING_DEALER,
        payload: null,
    });
    const res = await callWebService(
        callTypes.get,
        {},
        `${Config.wallet.listDealerRequest}?page=${page}`
    );

    if (res) {
        const { data } = res;
        dispatch({
            type: LISTING_DEALER,
            payload: data?.response?.data,
        });
        return true;
    }
  } catch {
        dispatch({
            type: LISTING_DEALER,
            payload: null,
        });
        return true;
  }
}

export const walletApprovalFinance = (page,status,flag = false) => async (dispatch) => {
    try {
      dispatch({
          type: LISTING_DEALER_APPROVAL,
          payload: null,
      });
      const res = await callWebService(
          callTypes.get,
          {},
          `${Config.wallet.walletApprovalFinance}?page=${page}&status=${status}&flag=${flag}`
      );
  
      if (res) {
          const { data } = res;
          dispatch({
              type: LISTING_DEALER_APPROVAL,
              payload: data?.response?.data,
          });
          return true;
      }
    } catch {
          dispatch({
              type: LISTING_DEALER_APPROVAL,
              payload: null,
          });
          return true;
    }
  }

export const walletListingDealerApproval = (page,status) => async (dispatch) => {
    try {
      dispatch({
          type: LISTING_DEALER_APPROVAL,
          payload: null,
      });
      const res = await callWebService(
          callTypes.get,
          {},
          `${Config.wallet.listDealerRequestApproval}?page=${page}&status=${status}`
      );
  
      if (res) {
          const { data } = res;
          dispatch({
              type: LISTING_DEALER_APPROVAL,
              payload: data?.response?.data,
          });
          return true;
      }
    } catch {
          dispatch({
              type: LISTING_DEALER_APPROVAL,
              payload: null,
          });
          return true;
    }
  }

export const walletListing = (page, walletType = 'INTERNAL') => async (dispatch) => {
    try {
        let roleId = parseInt(JSON.parse(window.localStorage.roles)[0]?.id) 
        let role_wise = roleId !== 49
        // if(roleId === 13){
        //     role_wise = false
        // }
        dispatch({
            type: LISTING,
            payload: null,
        });
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.wallet.list}?page=${page}&wallet_type=${walletType}&role_wise=${role_wise}&role_id=${roleId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: LISTING,
                payload: data?.response?.data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: LISTING,
            payload: null,
        });
        return true;
    }
}

export const transactionListing = (walletId,page) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.wallet.transaction}?wallet_id=${walletId}&page=${page}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: TRANSACTION,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: TRANSACTION,
            payload: null,
        });
        return true;
    }
}

export const approvalList = (wallet_id, page, sub_category = '') => async (dispatch) => {
    try {
        let role_wise = parseInt(JSON.parse(window.localStorage.roles)[0]?.id) !== 49
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.wallet.approvalList}?wallet_id=${wallet_id}&page=${page}&sub_category=${sub_category}&user_wise=${role_wise}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVAL_LIST,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: APPROVAL_LIST,
            payload: null,
        });
        return true;
    }
}

export const requestApprovalList = (page, status = '') => async (dispatch) => {
    try {

        let roleId = parseInt(JSON.parse(window.localStorage.roles)[0]?.id)
        setTimeout(() => {
            dispatch({
                type: APPROVAL_LIST_DATA,
                payload: null,
            });
        }, 500)
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.wallet.requestApprovalList}?page=${page}&status=${status}&role_id=${roleId}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: APPROVAL_LIST_DATA,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: APPROVAL_LIST_DATA,
            payload: null,
        });
        return true;
    }
}

export const fetchDealerDetails = (dealerId) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.wallet.fecthDealerData}?dealer_id=${dealerId}`
        );

        if (res) {
            //console.log(res);
            const { data } = res;
            dispatch({
                type: FETCH_DEALER_DATA,
                payload: data,
            });
            return data.response;
        }
    }
    catch {
        dispatch({
            type: FETCH_DEALER_DATA,
            payload: null,
        });
        return false;
    }
}

export const savePaymentForDealer = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.wallet.addPaymentForDealer}`
        );

        if (res) {
            const { data } = res;
            return data.response;
        }
    }
    catch {
        return false;
    }
}

export const addMoney = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.wallet.addMoney}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: ADD_MONEY,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: ADD_MONEY,
            payload: null,
        });
        return true;
    }
}

export const viewRequest = (id) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            {},
            `${Config.wallet.viewRequest}?id=${id}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: VIEW_REQUEST,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: VIEW_REQUEST,
            payload: null,
        });
        return true;
    }
}

export const approvalAction  = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.wallet.approveOrRejectWalletTransaction}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: REQUEST_ACTION,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: REQUEST_ACTION,
            payload: null,
        });
        return true;
    }
}

export const walletFinanceRequest = (data) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.post,
            data,
            `${Config.wallet.walletFinanceRequest}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: WALLET_FINANCE_REQUEST,
                payload: data,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: WALLET_FINANCE_REQUEST,
            payload: null,
        });
        return true;
    }
}
export const requesttransactionList = (id) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.wallet.requesttransactionList}?id=${id}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: REQUEST_TRANSACTION_LIST,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: REQUEST_TRANSACTION_LIST,
            payload: null,
        });
        return true;
    }
}

export const walletRequestList = (wallet_id) => async (dispatch) => {
    try {
        const res = await callWebService(
            callTypes.get,
            '',
            `${Config.wallet.walletRequestList}?wallet_id=${wallet_id}`
        );

        if (res) {
            const { data } = res;
            dispatch({
                type: WALLET_REQUEST_LIST,
                payload: data?.response,
            });
            return true;
        }
    }
    catch {
        dispatch({
            type: WALLET_REQUEST_LIST,
            payload: null,
        });
        return true;
    }
}








